export default __webpack_public_path__ + "static/media/mask.887358bd.svg";